import { atom, DefaultValue, selector } from "recoil"
import { MainWindowUser, PreviousMainWindowUser } from "./types"

export const defaultMainWindowUser = {
  uid: ""
}

export const defaultPreviousMainWindowUser = {
  uid: ""
}

const mainWindowUserAtom = atom<MainWindowUser>({
  key: "mainWindowUserAtom",
  default: defaultMainWindowUser
})

export const mainWindowUserSelector = selector({
  key: "mainWindowUserSelector",
  get: ({ get }) => {
    return get(mainWindowUserAtom)
  },
  set: ({ set }, mainWindowUser: MainWindowUser | DefaultValue) => {
    set(mainWindowUserAtom, mainWindowUser)
  }
})

const previousMainWindowUserAtom = atom<PreviousMainWindowUser>({
  key: "previousMainWindowUserAtom",
  default: defaultPreviousMainWindowUser
})

export const previousMainWindowUserSelector = selector({
  key: "previousMainWindowUserSelector",
  get: ({ get }) => {
    return get(previousMainWindowUserAtom)
  },
  set: (
    { set },
    previousMainWindowUser: PreviousMainWindowUser | DefaultValue
  ) => {
    set(previousMainWindowUserAtom, previousMainWindowUser)
  }
})
